var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 97,
    viewBox: "0 0 71 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9573 44.8451C28.6652 42.6939 31.6282 42.2191 34.1952 43.1494C36.7405 44.0719 38.6435 46.3362 38.5664 49.0525C38.4875 51.8307 36.528 54.1897 33.8596 54.9679C31.1958 55.7449 28.3361 54.7745 26.7787 52.4904C25.1968 50.1704 25.2007 47.0575 26.9573 44.8451Z",
    fill: "#EBFAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43555 59C11.1414 59 65.3041 59.1522 67.4717 59.6406C70.1229 60.2382 69.8281 61.5752 69.8281 66.0527C69.8281 69.6351 70 77.8884 70 81.6201C68.1937 82.8733 60.9313 89.9236 56.2725 89.9238C50.4489 89.9238 46.9124 88.7993 41 86.5C32 83 25.5652 86.0157 19.0625 88.9463C14.7277 90.8998 11.5924 89.9361 7.35742 87.6973C3.96941 85.9062 1.70604 82.5774 1 81.582V63.8438C1.00007 61.6048 3.7299 59.0002 7.43555 59ZM16.3721 34.1191C18.9076 34.1191 54.3332 33.5221 56.1455 33.7871C57.2391 33.9473 58.6971 35.2271 58.6973 37.4424C58.6973 39.215 59.0615 42.9211 59.0615 44.7676C57.2383 45.4866 52.401 48.7207 49.2178 48.7207C45.2386 48.7207 42.9341 48.3551 39.374 46.5645C34.8465 44.2873 29.8615 46.5347 25.5205 47.6426C21.1794 48.7505 18.9038 49.2602 16.0098 48.1523C13.6948 47.2661 12.1485 45.6195 11.666 45.127V36.3027C11.666 35.1948 13.8398 34.1191 16.3721 34.1191ZM21.1455 14.375C22.9466 13.8688 48.6251 14.158 49.9473 14.375C51.4056 14.6144 52.1348 15.7759 52.1348 17.3701C52.1348 18.6455 52.499 21.0728 52.499 22.4014C51.1527 22.9187 47.9454 24.8808 45.5947 24.8809C42.6562 24.8809 41.2744 25.1272 38.6455 23.8389C35.3021 22.2004 31.3004 23.3074 28.0947 24.1045C24.889 24.9016 23.2084 25.2688 21.0713 24.4717C19.3619 23.8339 18.5847 22.3904 18.2285 22.0361V18.0889C18.2285 17.2917 18.5935 15.0937 21.1455 14.375Z",
    fill: "url(#paint0_linear_3576_225277)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0269 70.2971C23.3196 72.3519 20.9185 74.2052 20.9187 75.14C20.9187 75.2071 20.9268 75.271 20.9521 75.3287C22.7187 79.3589 31.2699 82.3427 38.766 79.0668C46.2627 75.7906 48.4257 69.2684 48.186 63.7092C48.1794 63.5531 48.112 63.4272 47.9908 63.3293C46.7979 62.3687 40.3267 64.139 33.5237 67.1122C31.118 68.1634 28.9046 69.2563 27.0269 70.2971Z",
    fill: "white",
    stroke: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0361 75.5117C23.524 75.2099 26.8141 74.7453 29.6554 73.896C37.4904 71.5541 43.3338 67.603 47.3396 64.1796",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0361 75.5117C23.524 75.2099 26.8141 74.7453 29.6554 73.896C37.4904 71.5541 43.3338 67.603 47.3396 64.1796",
    stroke: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 42.662C12.9742 43.8558 16.6866 46.192 21.0788 45.9874C26.569 45.7316 27.7454 42.9178 34.0199 42.9178C40.2944 42.9178 41.0665 45.9874 48.1253 45.9874C55.1842 45.9874 55.7816 42.4063 58.3337 42.4062",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2295 20.9972C19.169 21.7135 21.8373 23.1152 24.9942 22.9924C28.9403 22.839 29.7859 21.1507 34.2957 21.1507C38.8055 21.1507 39.3604 22.9924 44.4339 22.9924C49.5075 22.9924 49.9369 20.8438 51.7712 20.8438",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 85.4093C2.91993 87.3192 8.37255 91.0572 14.8235 90.7298C22.8873 90.3205 24.6152 85.8185 33.8309 85.8185C43.0466 85.8185 44.1805 90.7298 54.5482 90.7298C64.9158 90.7298 65.7933 85 69.5417 85",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 57.2812H64C67.0376 57.2812 69.5 59.7437 69.5 62.7812V95.8125H0.5V62.7812C0.5 59.7437 2.96243 57.2812 6 57.2812Z",
    stroke: "#222222"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9375 31.4062H53.0625C56.1001 31.4062 58.5625 33.8687 58.5625 36.9062V57H11.4375V36.9062C11.4375 33.8687 13.8999 31.4062 16.9375 31.4062Z",
    stroke: "#222222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12.7188H46.5C49.5376 12.7188 52 15.1812 52 18.2188V31.125H18V18.2188C18 15.1812 20.4624 12.7188 23.5 12.7188Z",
    stroke: "#222222"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8955 0.5C30.8275 0.5 31.583 1.25552 31.583 2.1875V12.4375H28.208V2.1875C28.208 1.25552 28.9635 0.5 29.8955 0.5Z",
    stroke: "#222222"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 0.5C40.307 0.5 41.0625 1.25552 41.0625 2.1875V12.4375H37.6875V2.1875C37.6875 1.25552 38.443 0.5 39.375 0.5Z",
    stroke: "#222222"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3576_225277",
    x1: 62.41,
    y1: 14.0938,
    x2: -7.85643,
    y2: 42.5143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04B6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E75FD0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.29f579986ffc4db50232534ce07b412f.svg";
export { ForwardRef as ReactComponent };